function numberToTamilRupees(num) {
  var a = [
    "",
    "ஒன்று ",
    "இரண்டு ",
    "மூன்று ",
    "நான்கு ",
    "ஐந்து ",
    "ஆறு ",
    "ஏழு ",
    "எட்டு ",
    "ஒன்பது ",
    "பத்து ",
    "பதினொரு ",
    "பன்னிரண்டு ",
    "பதின்மூன்று ",
    "பதினான்கு ",
    "பதினைந்து ",
    "பதினாறு ",
    "பதினேழு ",
    "பதினெட்டு ",
    "பத்தொன்பது ",
  ];
  var b = [
    "",
    "",
    "இருபது",
    "முப்பது",
    "நாற்பது",
    "ஐம்பது",
    "அறுபது",
    "எழுபது",
    "எண்பது",
    "தொண்ணூறு",
  ];
  if ((num = num.toString()).length > 9) return "overflow";
  var n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return;
  var str = "";
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "கோடி "
      : "";
  str +=
    n[2] != 0
      ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "லட்சம் "
      : "";
  str +=
    n[3] != 0
      ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "ஆயிரம் "
      : "";
  str +=
    n[4] != 0
      ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "நூறு "
      : "";
  str +=
    n[5] != 0
      ? (str != "" ? "மற்றும் " : "") +
        (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
        "மட்டுமே "
      : "மட்டுமே";
  return str;
}

export default numberToTamilRupees;
